export default __webpack_public_path__ + "static/media/world-padel-store.1ffcb40d.png";